import { Modal } from 'bootstrap';

export default class AutoOpenModal {
    public constructor(element: Element) {
        new Modal(element as HTMLElement).show();
    }
}
